import { ComponentProps } from 'react'

export enum Direction {
  RIGHT = 90,
}

export type RotationAngle = 0 | 90 | 180 | 270

export type RotatedImage = {
  angle: RotationAngle
  images: {
    [key in RotationAngle]?: { src: string; width: number; height: number }
  }
}

export type CrossOrigin = ComponentProps<'img'>['crossOrigin']
